module.exports = __webpack_public_path__ + "Lato-Bold.d0549ba90a0800d86d58.woff";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/Lato-Bold.woff
// module id = ../../../../../src/assets/fonts/Lato-Bold.woff
// module chunks = styles